import { __decorate } from "tslib";
import { observable, action, makeObservable } from 'mobx';
var UIStore = /** @class */ (function () {
    function UIStore(rootStore) {
        Object.defineProperty(this, "ucfStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "appState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'success'
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "appShowMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "appMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "inlineEditAppMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "newToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "currentPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "showProductFilter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "mobileTopBar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                title: '',
                canBack: false,
                actionComponent: null,
            }
        });
        Object.defineProperty(this, "desktopActiveMenu", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "mobileActiveMenu", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "lastYPosition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        makeObservable(this);
        this.ucfStore = rootStore;
    }
    Object.defineProperty(UIStore.prototype, "setLoading", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isLoading) {
            this.loading = isLoading;
        }
    });
    Object.defineProperty(UIStore.prototype, "setError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isError) {
            this.error = isError;
        }
    });
    Object.defineProperty(UIStore.prototype, "setLastYPosition", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (y) {
            this.lastYPosition = y;
        }
    });
    Object.defineProperty(UIStore.prototype, "setCurrentPath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (path) {
            this.currentPath = path;
        }
    });
    Object.defineProperty(UIStore.prototype, "setTopNavBar", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (title, canBack, actionComponent) {
            this.mobileTopBar = {
                title: title,
                canBack: canBack,
                actionComponent: actionComponent,
            };
        }
    });
    Object.defineProperty(UIStore.prototype, "setActiveMenu", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (desktopMenu, mobileMenu) {
            this.desktopActiveMenu = desktopMenu;
            this.mobileActiveMenu = mobileMenu;
        }
    });
    Object.defineProperty(UIStore.prototype, "showErrorValidation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            this.appState = 'fail';
            this.appMessage = message;
            this.appShowMessage = true;
        }
    });
    __decorate([
        observable
    ], UIStore.prototype, "ucfStore", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "loading", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "appState", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "error", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "appShowMessage", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "appMessage", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "inlineEditAppMessage", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "newToken", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "currentPath", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "showProductFilter", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "mobileTopBar", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "desktopActiveMenu", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "mobileActiveMenu", void 0);
    __decorate([
        observable
    ], UIStore.prototype, "lastYPosition", void 0);
    __decorate([
        action
    ], UIStore.prototype, "setLoading", null);
    __decorate([
        action
    ], UIStore.prototype, "setError", null);
    __decorate([
        action
    ], UIStore.prototype, "setLastYPosition", null);
    __decorate([
        action
    ], UIStore.prototype, "setCurrentPath", null);
    return UIStore;
}());
export { UIStore };
//# sourceMappingURL=data:application/json;base64,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